/**
 * Checks if the passed value is null or undefined.
 *
 * @param {any} value
 * @returns {boolean}
 */
export default function isNullOrUndefined(value) {
    return value === null || value === undefined;
}